import './config/sentry'

import './index.css'

import { StrictMode } from 'react'

import App from '@/App'
import EditorHeader from '@/editor/Header'
import AppBar from '@/pages/projectList/components/AppBar'
import { router } from '@/services/Router'
import { AppState, Auth0Provider } from '@auth0/auth0-react'
import { AccountSettingsTab } from '@infraloop/account-settings'
import { StylesProvider } from '@infraloop/common'
import { EditorProvider } from '@infraloop/editor'
import { AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN } from '@infraloop/services'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'

import './config/mixpanel'

const onRedirectCallback = (appState: AppState | undefined) => {
  void router.navigate(appState?.returnTo || window.location.pathname, { replace: true })
}

const queryClient = new QueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <QueryClientProvider client={queryClient}>
        <StylesProvider>
          <EditorProvider
            header={<EditorHeader />}
            topNavbar={<AppBar />}
            planManagementUrl={`/user/${AccountSettingsTab.Billing}`}
          >
            <App />
          </EditorProvider>
        </StylesProvider>
      </QueryClientProvider>
    </Auth0Provider>
  </StrictMode>,
)
